export default {
  data() {
    return {
      //企业基本信息
      BASIC_INFO_SCHEMA: {
        name: {
          label: '客户名称',
          type: 'input',
          rules: [{ required: true, message: '请输入客户名称' }],
          disabled: true,
        },
        code: {
          label: '客户编码',
          type: 'input',
          rules: [{ required: true, message: '请输入客户编码' }],
          disabled: true,
        },
        currency: {
          label: '货币',
          type: 'input',
          rules: [{ required: true, message: '请输入货币' }],
          disabled: true,
        },
        stdAccountPeriod: {
          label: '标准账期',
          type: 'input',
          rules: [{ required: true, message: '请输入标准账期' }],
          disabled: true,
        },
        // business: {
        //   label: '业务类型',
        //   type: 'select',
        //   disabled: true,
        //   optionList: [],
        //   rules: [{ required: true, message: '请选择业务类型' }],
        //   emit: 'handleBusiTypeChange',
        // },
        business: {
          label: '业务类型',
          type: 'select',
          disabled: true,
          rules: [{ required: true, message: '请选择业务类型' }],
          allowClear: true,
          slotName: 'business', // 具名插槽
        },
        region: {
          label: '大区',
          type: 'select',
          disabled: true,
          allowClear: true,
          slotName: 'region',
        },
        model: {
          label: '业务模式',
          disabled: true,
          type: 'select',
          rules: [{ required: true, message: '请选择业务模式' }],
          allowClear: true,
          slotName: 'model', // 具名插槽
        },
        sapRiskType: {
          label: 'SAP风险类型',
          type: 'input',
          disabled: true,
        },
        signDate: {
          label: '联想签约日期',
          type: 'datePicker', // datePicker类型
          dateFormat: 'YYYY-MM-DD',
          rules: [{ required: true, message: '请选择联想签约日期' }], // 校验
          disabled: true,
        },
        registerDate: {
          label: '公司注册日期',
          type: 'datePicker', // datePicker类型
          dateFormat: 'YYYY-MM-DD',
          rules: [{ required: true, message: '请选择公司注册日期' }], // 校验
          disabled: true,
        },
        membershipGroup: {
          label: '所属集团名称',
          type: 'input',
          disabled: true,
        },
        soldPartyNo: {
          label: '售达方编号',
          type: 'input',
          disabled: true,
        },
        registeredNo: {
          label: '社会信用代码',
          type: 'input',
          disabled: true,
        },
        creditManager: {
          label: '信用主管',
          type: 'select',
          rules: [{ required: true, message: '请选择信用主管' }],
          disabled: true,
          optionList: [],
        },
        businessSupervisor: {
          label: '商务主管',
          type: 'select',
          disabled: true,
          optionList: [],
        },
        receivableParty: {
          label: '应收人员',
          type: 'input',
          disabled: true,
        },
        defaultScoreType: {
          label: '默认评分卡',
          type: 'select',
          rules: [{ required: true, message: '请选择默认评分卡' }], // 校验
          disabled: true,
          optionList: [],
        },
        national: {
          label: '国家',
          type: 'select',
          rules: [{ required: true, message: '请选择国家' }], // 校验
          disabled: true,
          optionList: [],
        },
        englishName: {
          label: 'Customer name',
          type: 'input',
          disabled: true,
        },
        tickerSymbol: {
          label: '证券代码',
          type: 'input',
          disabled: true,
        },
        vendor: {
          label: 'Vendor',
          type: 'input',
          disabled: true,
        },
      },
      //企业额外信息
      EXTRA_INFO_SCHEMA: {
        legalPerson: {
          label: '企业法人',
          type: 'input',
          disabled: true,
        },
        legalPersonCard: {
          label: '法人身份证信息',
          type: 'input',
          disabled: true,
        },
        shareholder: {
          label: '企业股东',
          type: 'input',
          disabled: true,
        },
        shareholderCard: {
          label: '股东身份证信息',
          type: 'input',
          disabled: true,
        },
        registerMoney: {
          label: '注册资本(元)',
          type: 'input',
          disabled: true,
        },
        shareholderNature: {
          label: '股东性质',
          type: 'select',
          disabled: true,
        },
        registerCode: {
          label: '客户注册号',
          type: 'input',
          disabled: true,
        },
        lastRefundAvgDays: {
          label: '上财年加权平均回款天数',
          type: 'input',
          disabled: true,
        },
        lastExpiryTimes: {
          label: '上财年逾期次数',
          type: 'input',
          disabled: true,
        },
        lastExpiryRate: {
          label: '上财年3天以上逾期率(%)',
          type: 'input',
          disabled: true,
        },
        expiryAvgDays: {
          label: '近三财年加权平均逾期天数',
          type: 'input',
          disabled: true,
        },
        expiryAvgRate: {
          label: '近三财年3天以上逾期率(%)',
          type: 'input',
          disabled: true,
        },
        isExpiryRisk: {
          label: '上财年是否出现真实逾期风险',
          type: 'select',
          optionList: [
            {
              label: '否',
              value: '2',
            },
            {
              label: '是',
              value: '1',
            },
          ],
          disabled: true,
        },
        isExpiry: {
          label: '目前是否存在真实逾期',
          type: 'select',
          optionList: [
            {
              label: '否',
              value: '2',
            },
            {
              label: '是',
              value: '1',
            },
            {
              label: '新客户',
              value: '3',
            },
          ],
          disabled: true,
        },
        purchasePlan: {
          label: '未来一年联想直接采购预估额(元)',
          type: 'input',
          disabled: true,
        },
        purchase: {
          label: '近三年进货额(元)',
          type: 'input',
          disabledestablishYearList: true,
        },
        purchaseRateIncrement: {
          label: '联想直接采购额年增长率(%)',
          type: 'input',
          disabled: true,
        },
        level: {
          label: '客户级别',
          type: 'input',
          disabled: true,
        },
        industryLevel: {
          label: '行业风险级别',
          type: 'select',
          optionList: [
            {
              label: '绿色',
              value: 1,
            },
            {
              label: '黄色',
              value: 2,
            },
            {
              label: '红色',
              value: 3,
            },
          ],
          disabled: true,
        },
        regionLevel: {
          label: '地域风险级别',
          type: 'select',
          optionList: [
            {
              label: '绿色',
              value: 1,
            },
            {
              label: '黄色',
              value: 2,
            },
            {
              label: '红色',
              value: 3,
            },
          ],
          disabled: true,
        },
        establishYear: {
          label: '成立时间',
          disabled: true,
          type: 'select',
          optionList: [],
        },
        coopTime: {
          label: '合作年限',
          type: 'select',
          disabled: true,
          optionList: [],
        },
        actualReceipt: {
          label: '实收资本(元)',
          type: 'input',
          disabled: true,
        },
        subjectiveEvaluation: {
          label: '主观评价',
          type: 'input',
          rules: [{ required: true, message: '请选择主观评价' }],
          disabled: true,
        },
      },
      labelCol: {
        xs: { span: 9 },
      },
      wrapperCol: {
        xs: { span: 14 },
      },
      //企业基本信息-数据
      sourceDataBasic: {
        id: '',
        name: '',
        code: '',
        business: '',
        currency: '',
        stdAccountPeriod: '',
        sapRiskType: '',
        region: '',
        model: '',
        signDate: '',
        registerDate: '',
        membershipGroup: '',
        soldPartyNo: '',
        registeredNo: '',
        creditManager: [],
        businessSupervisor: [],
        receivableParty: '',
        defaultScoreType: '',
        national: '',
        englishName: '',
        tickerSymbol: '',
        vendor: '',
      },
      //企业额外信息-数据
      sourceDataExtra: {
        id: '',
        companyCode: this.companyCode,
        industryGroup: '',
        legalPerson: '',
        legalPersonCard: '',
        shareholder: '',
        shareholderCard: '',
        registerMoney: '',
        shareholderNature: '',
        registerCode: '',
        lastRefundAvgDays: '',
        lastExpiryTimes: '',
        lastExpiryRate: '',
        expiryAvgDays: '',
        expiryAvgRate: '',
        isExpiryRisk: '',
        isExpiry: '',
        purchasePlan: '',
        purchase: '',
        purchaseRateIncrement: '',
        level: '',
        industryLevel: '',
        regionLevel: '',
        establishYear: '',
        coopTime: '',
        actualReceipt: '',
        subjectiveEvaluation: '',
      },
      formLayout: 'horizontal',
      labelColExtra: {
        xs: { span: 13 },
      },
      wrapperColExtra: {
        xs: { span: 10 },
      },
      defaultColXs: 24,
      defaultColSm: 24,
      defaultColMd: 12,
      defaultColLg: 12,
      defaultColXl: 12,
    }
  },
}
